/* eslint-disable no-restricted-syntax */
const equalSets = (setA, setB) => {
  if (setA.length !== setB.length) return false;
  for (const a of setA) if (!setB.find((b) => b.ec === a.ec)) return false;
  return true;
};
const findContradictEc = (ecItem, bucket) => {
  for (const ec of ecItem.excludes)
    if (bucket.find((i) => i.ec === ec)) return ec;
  return null;
};
const pushBucket = (destBuckets, srcBuckets) => {
  for (const bucket of srcBuckets)
    if (!destBuckets.some((dest) => equalSets(dest, bucket)))
      destBuckets.push(bucket);
};

const processMust = (EC, parent, relation, buckets, conflictECs) => {
  const newBuckets = [];
  const me = conflictECs.find(({ ec }) => EC === ec);
  for (const bucket of buckets) {
    if (!me || bucket.find(({ ec }) => EC === ec)) newBuckets.push(bucket);
    else {
      const copyBucket = [...bucket];
      copyBucket.push({ ...me, parent, relation });
      if (!me.includes.length && !me.requires.length)
        newBuckets.push(copyBucket);
      else {
        const myNewBuckets = [];
        const myrequires = me.requires.filter((req) => req.length > 0);
        const requires = myrequires.length ? myrequires : [[]];
        for (const R of requires) {
          let myBuckets = [[...copyBucket]];
          for (const ec of me.includes) {
            const newEcBuckets = [];
            for (const myBucket of myBuckets) {
              const ecBuckets = processMust(
                ec,
                EC,
                'includes',
                [myBucket],
                conflictECs,
              );
              newEcBuckets.push(...ecBuckets);
            }
            myBuckets = newEcBuckets;
          }
          for (const ec of R) {
            const newEcBuckets = [];
            for (const myBucket of myBuckets) {
              const ecBuckets = processMust(
                ec,
                EC,
                'requires',
                [myBucket],
                conflictECs,
              );
              newEcBuckets.push(...ecBuckets);
            }
            myBuckets = newEcBuckets;
          }
          pushBucket(myNewBuckets, myBuckets);
        }
        pushBucket(newBuckets, myNewBuckets);
      }
    }
  }
  return newBuckets;
};

const traceConflict = (ec, list) => {
  const ecItem = ec ? list.find((i) => i.ec === ec) : list[list.length - 1];
  if (ecItem.parent) {
    const trace = traceConflict(ecItem.parent, list);
    return `${trace} ${trace.search(' ') < 0 ? '' : 'which '}${
      ecItem.relation
    } ${ecItem.ec}`;
  }
  return ecItem.ec;
};

const getUniquePaths = (paths) => {
  const unique = [];
  paths.forEach((path) => {
    if (
      !unique.find(
        (u) =>
          u.includeTrace === path.includeTrace &&
          u.excludeTrace === path.excludeTrace && // for invalid path
          u.excludes === path.excludes, // for valid path
      )
    )
      unique.push(path);
  });
  return unique;
};

const validateEcConflict = (ec, conflictECs) => {
  const musts = processMust(ec, undefined, undefined, [[]], conflictECs);
  const results = musts.map((mustSet) => {
    for (const ecItem of mustSet) {
      const contradictEc = findContradictEc(ecItem, mustSet);
      const excTrace = traceConflict(ecItem.ec, mustSet);
      if (contradictEc)
        return {
          isValid: false,
          rootEc: ec,
          contradictEc,
          includeTrace: traceConflict(contradictEc, mustSet),
          excludeTrace: `${excTrace} ${
            excTrace.search(' ') < 0 ? '' : 'which '
          }excludes ${contradictEc}`,
        };
    }
    return {
      isValid: true,
      rootEc: ec,
      includeTrace: traceConflict(undefined, mustSet),
      excludes: mustSet[0].excludes.join(', '),
    };
  });
  const validPaths = getUniquePaths(results.filter((res) => res.isValid));
  const invalidPaths = getUniquePaths(results.filter((res) => !res.isValid));
  let isValid;
  if (invalidPaths.length === 0) isValid = 2;
  else isValid = validPaths.length > 0 ? 1 : 0;
  return { ec, isValid, validPaths, invalidPaths };
};

// find contradicting conflicts
export const getInvalidConflicts = (conflictECs) => {
  const invalidConflictECs = [];
  conflictECs.forEach((EC) => {
    const result = validateEcConflict(EC.ec, conflictECs);
    if (result.isValid < 2) invalidConflictECs.push({ id: EC.id, ...result });
  });
  return invalidConflictECs;
};

export const getInvalidConflictByEC = (invalidECs, ec) => {
  return invalidECs.find((invalidEC) => invalidEC.ec === ec);
};

export const getInvalidConflictECsByEC = (invalidECs, ec) => {
  const regex = `(^${ec}$)|(^${ec} )|( ${ec} )|( ${ec}$)`;
  return invalidECs.filter(
    ({ isValid, invalidPaths }) =>
      isValid === 0 &&
      invalidPaths.some(
        ({ includeTrace, excludeTrace }) =>
          includeTrace.search(regex) >= 0 || excludeTrace.search(regex) >= 0,
      ),
  );
};

export const getUnviableConflictECs = (invalidConflictECs) => {
  return invalidConflictECs
    .filter(({ isValid }) => isValid === 0)
    .map(({ ec }) => ec);
};

export const exportsForTesting = {
  equalSets,
  pushBucket,
};
